import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_BASE_URL; 
// const SOCKET_URL = process.env.REACT_APP_SOCKET_BASE_URL;

const socket = SOCKET_URL
  ? io(SOCKET_URL, {
      autoConnect: false, 
      withCredentials: true,
      path: "/notification-api/socket.io",
      transports: ["websocket"],
    })
  : null;

export default socket;
